'use client';

import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useRouter } from 'next/router';
import type { CampaignConfig } from '../config.interface';
import { useResponsiveBreakpoints } from '@/hooks/useResponsiveBreakpoints';
import { useBannerSx } from '@/ui/Banner';
import { Text } from '@/ui/Text';
import { DonateButton } from '@/ui/buttons/DonateButton';
import { KnowMoreButton } from '@/ui/buttons/KnowMoreButton';
import type { CampaignText } from '@/infrastructure/zustand/types/campaign.interface';

export const CampaignResumeShortDonate = ({
	campaignId,
	finished,
	showDonateButton = true,
	campaignTexts,
	config,
}: {
	campaignId: string;
	finished: boolean;
	showDonateButton: boolean | undefined;
	campaignTexts: CampaignText;
	config: CampaignConfig;
}) => {
	const { extraSmall, small, large, medium } = useResponsiveBreakpoints();
	const router = useRouter();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
	const sx = useBannerSx(theme);

	const justifyContent = extraSmall || small || medium || large ? 'center' : 'flex-start';
	const isDonatePage = router.pathname.includes('donate');

	if ((config.isInformativeCampaign && !showDonateButton && !finished) || isDonatePage) {
		return null;
	}

	return (
		<Box
			display="flex"
			justifyContent={justifyContent}
			marginTop={isDesktop ? '3rem' : undefined}
			paddingBottom={'2rem'}
		>
			<Box width={'100%'} display={'flex'} flexDirection={'column'} gap={'1rem'} alignItems={'center'}>
				{isMobile && config.isAlala && (
					<Text
						disableColorDetection
						text={campaignTexts?.name}
						sx={sx.campaignName}
						style={{ color: theme.palette.primary.main }}
					/>
				)}
				{
					<Box
						display={isMobile ? 'flex' : 'none'}
						width={'100%'}
						flexDirection={'column'}
						gap={'1rem'}
						alignItems={'center'}
					>
						<DonateButton config={config} isFunded={finished} campaignId={campaignId} color={config.buttonColor} />
						<Box
							display={config.showCampaignResumeShortKnowMoreButton ? 'flex' : 'none'}
							width={'100%'}
							flexDirection={'column'}
							gap={'1rem'}
							alignItems={'center'}
						>
							<KnowMoreButton />
						</Box>
					</Box>
				}
			</Box>
		</Box>
	);
};
